const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};

export const getStatusMessage = (status, date) => {
  const formattedDate = formatDate(date);
  
  switch (status) {
    // Fluxo de auditoria (EG-22/EG-24)
    case 'em auditoria':
      return `O questionário foi enviado para auditoria no dia ${formattedDate}.`;
    case 'em conferência final':
      return `O questionário foi reenviado para conferência final no dia ${formattedDate}.`;
    case 'em ajustes':
      return `O questionário foi devolvido para ajustes no dia ${formattedDate}.`;
    // Legado (avaliação)
    case 'em avaliação':
      return `O questionário foi enviado para avaliação no dia ${formattedDate}.`;
    case 'em revisão':
      return `O questionário foi enviado para revisão no dia ${formattedDate}.`;
    case 'aguardando adequações':
      return `O questionário foi enviado para adequações no dia ${formattedDate}.`;
    default:
      return null;
  }
};